import { render, staticRenderFns } from "./PackageReports.vue?vue&type=template&id=4a2d8aec&"
import script from "./PackageReports.vue?vue&type=script&lang=js&"
export * from "./PackageReports.vue?vue&type=script&lang=js&"
import style0 from "./PackageReports.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PackageReports.vue"
export default component.exports